export default {
  title: 'Carrito',
  buttons: {
    login_to_checkout: 'Inicia sesión para pagar',
    checkout: 'Pagar',
  },
  go_to_menu: 'Ir al menú',
  toasts: {
    cashback_points_removed: 'Tu saldo de puntos ha cambiado, así que hemos quitado los puntos de este pedido.',
  },
};
